import axios from "axios";
import { BASE_API_URL } from "../consts";

export interface ExchangeRate {
  _id: string;
  clientId: string;
  fromCurrency: string;
  toCurrency: string;
  rate: number;
  source: "manual" | "auto";
  updatedAt: string;
}

const withAuthHeaders = (token?: string) => {
  if (!token) return {};
  return { headers: { "x-access-token": token } };
};

export const getExchangeRates = async (
  clientId: string,
  token?: string,
): Promise<ExchangeRate[]> => {
  const { data } = await axios.get(
    `${BASE_API_URL}/${clientId}/exchange-rates`,
    withAuthHeaders(token),
  );
  return data;
};

export const upsertExchangeRate = async (
  clientId: string,
  fromCurrency: string,
  toCurrency: string,
  rate: number,
  token?: string,
): Promise<ExchangeRate> => {
  const { data } = await axios.post(
    `${BASE_API_URL}/${clientId}/exchange-rates`,
    { fromCurrency, toCurrency, rate },
    withAuthHeaders(token),
  );
  return data;
};

export const fetchLiveExchangeRate = async (
  clientId: string,
  fromCurrency: string,
  toCurrency: string,
  token?: string,
): Promise<ExchangeRate> => {
  const { data } = await axios.post(
    `${BASE_API_URL}/${clientId}/exchange-rates/fetch-live`,
    { fromCurrency, toCurrency },
    withAuthHeaders(token),
  );
  return data;
};
